/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  SetAuthenticationHostRequestBody,
  SetAuthenticationHostRequestBody$Outbound,
  SetAuthenticationHostRequestBody$outboundSchema,
} from "../components/setauthenticationhostrequestbody.js";

export type SetOrganizationUserSessionIssuerAuthenticationHostSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type SetOrganizationUserSessionIssuerAuthenticationHostRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  setAuthenticationHostRequestBody: SetAuthenticationHostRequestBody;
};

/** @internal */
export type SetOrganizationUserSessionIssuerAuthenticationHostSecurity$Outbound =
  {
    "session_header_Gram-Session"?: string | undefined;
  };

/** @internal */
export const SetOrganizationUserSessionIssuerAuthenticationHostSecurity$outboundSchema:
  z.ZodMiniType<
    SetOrganizationUserSessionIssuerAuthenticationHostSecurity$Outbound,
    SetOrganizationUserSessionIssuerAuthenticationHostSecurity
  > = z.pipe(
    z.object({
      sessionHeaderGramSession: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function setOrganizationUserSessionIssuerAuthenticationHostSecurityToJSON(
  setOrganizationUserSessionIssuerAuthenticationHostSecurity:
    SetOrganizationUserSessionIssuerAuthenticationHostSecurity,
): string {
  return JSON.stringify(
    SetOrganizationUserSessionIssuerAuthenticationHostSecurity$outboundSchema
      .parse(setOrganizationUserSessionIssuerAuthenticationHostSecurity),
  );
}

/** @internal */
export type SetOrganizationUserSessionIssuerAuthenticationHostRequest$Outbound =
  {
    "Gram-Session"?: string | undefined;
    SetAuthenticationHostRequestBody: SetAuthenticationHostRequestBody$Outbound;
  };

/** @internal */
export const SetOrganizationUserSessionIssuerAuthenticationHostRequest$outboundSchema:
  z.ZodMiniType<
    SetOrganizationUserSessionIssuerAuthenticationHostRequest$Outbound,
    SetOrganizationUserSessionIssuerAuthenticationHostRequest
  > = z.pipe(
    z.object({
      gramSession: z.optional(z.string()),
      setAuthenticationHostRequestBody:
        SetAuthenticationHostRequestBody$outboundSchema,
    }),
    z.transform((v) => {
      return remap$(v, {
        gramSession: "Gram-Session",
        setAuthenticationHostRequestBody: "SetAuthenticationHostRequestBody",
      });
    }),
  );

export function setOrganizationUserSessionIssuerAuthenticationHostRequestToJSON(
  setOrganizationUserSessionIssuerAuthenticationHostRequest:
    SetOrganizationUserSessionIssuerAuthenticationHostRequest,
): string {
  return JSON.stringify(
    SetOrganizationUserSessionIssuerAuthenticationHostRequest$outboundSchema
      .parse(setOrganizationUserSessionIssuerAuthenticationHostRequest),
  );
}
